(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 7);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GAS_BULK_URL = exports.GAS_BULK_URL = 'https://mgas.prod.public.atl-paas.net/v1/events';
var CLOUD_ANALYTICS_URL = exports.CLOUD_ANALYTICS_URL = '/rest/analytics/1.0/publish/bulk';
var CONFLUENCE_URL_PREFIX = exports.CONFLUENCE_URL_PREFIX = '/wiki';
var BATCH_INTERVAL_MS = exports.BATCH_INTERVAL_MS = 5000;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SafeString = exports.SafeString = function SafeString(value) {
    var _this = this;

    _classCallCheck(this, SafeString);

    this.value = value;
    this.valueOf = this.toString = this.toJSON = function () {
        return _this.value;
    };
};

/**
 * Use this when you explicitly need to collect user entered data. Such as NPS survey responses.
 * @param value
 */


var dangerouslyCreateSafeString = exports.dangerouslyCreateSafeString = function dangerouslyCreateSafeString(value) {
    return new SafeString(value);
};

var isSafeString = exports.isSafeString = function isSafeString(value) {
    return value instanceof SafeString;
};

/**
 * Provide a list of acceptable values to ensure we do not unintentionally capture user data
 * @param {Array} allowedStrings - Static string values representing allowed words for this property
 * @returns {SafeString}
 */
var markAsSafe = exports.markAsSafe = function markAsSafe() {
    for (var _len = arguments.length, allowedStrings = Array(_len), _key = 0; _key < _len; _key++) {
        allowedStrings[_key] = arguments[_key];
    }

    return function (value) {
        return allowedStrings.includes(value) ? Object.freeze(new SafeString(value)) : value;
    };
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseAnalytics = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _default = __webpack_require__(0);

var _Beacon = __webpack_require__(8);

var _PrivacySafeString = __webpack_require__(1);

var _AnalyticsLogger = __webpack_require__(9);

var _AnalyticsLogger2 = _interopRequireDefault(_AnalyticsLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var isNumberOrNumericString = function isNumberOrNumericString(value) {
  return !isNaN(value);
};

var isNull = function isNull(value) {
  return value === null;
};
var isBoolean = function isBoolean(value) {
  return value === true || value === false;
};

/**
 * Is of a type that will not reveal any PII
 * OR
 * is explicitly marked as being safe of PII
 * @param value
 */
var isPrivacySafe = function isPrivacySafe(value) {
  return isNull(value) || isBoolean(value) || isNumberOrNumericString(value) || (0, _PrivacySafeString.isSafeString)(value);
};

/**
 * Extend this to include "whitelisted" keys where the values will be deemed safe
 * @param key
 */
var isPrivacySafeAttributeKey = function isPrivacySafeAttributeKey(key) {
  return key === 'spaceKey';
};

/*eslint no-unused-vars: ["error", { "argsIgnorePattern": "name|properties|events" }]*/
/**
 * Abstract analytics client implementation
 */

var BaseAnalytics = exports.BaseAnalytics = function () {
  function BaseAnalytics() {
    var _this = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, BaseAnalytics);

    this.eventPrefix = options.eventPrefix || '';
    this.devMode = options.devMode;
    this.batch_interval_ms = options.batchIntervalMs || _default.BATCH_INTERVAL_MS;
    this.options = options;
    this._requestQueue = [];

    if (typeof window !== "undefined" && window.addEventListener) {
      window.addEventListener("unload", function () {
        _this.handlePageUnload();
      });
    }
  }

  _createClass(BaseAnalytics, [{
    key: 'url',
    value: function url() {
      throw new Error('override url()');
    }
  }, {
    key: 'createRequest',
    value: function createRequest(name) {
      var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      throw new Error('You must override createRequest().');
    }

    /**
     * Process an event for sending.
     *
     * @param {string} name - name of the analytics event
     * @param {object} properties - flat object of arbitrary key value properties
     * @param {object} options - additional options for this request
     *
     * use { options.immediate: true } to bypass batching for important events that are likely to be lost,
     * e.g. events fired just before page navigation.
     */

  }, {
    key: 'trigger',
    value: function trigger(name) {
      var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { immediate: false };

      if (!name) {
        throw new Error("Name must be provided when sending an event.");
      }
      var eventName = '' + (this.eventPrefix ? this.eventPrefix + "." : "") + name;

      var request = this.createRequest(eventName, this.sanitizeAnalyticsData(properties));

      if (this.devMode) {
        _AnalyticsLogger2.default.log(JSON.stringify(request, null, 2));
      }

      if (options.immediate) {
        this.sendEventsToRemote([request]);
      } else {
        this.pushToQueue(request);
        this.startInterval();
      }
    }
  }, {
    key: 'setQueue',
    value: function setQueue(newQueue) {
      this._requestQueue = newQueue;
    }
  }, {
    key: 'getQueue',
    value: function getQueue() {
      return this._requestQueue;
    }
  }, {
    key: 'pushToQueue',
    value: function pushToQueue(request) {
      this.getQueue().push(request);
    }

    /**
     * Optimistically empty the queue and send them.
     */

  }, {
    key: 'processQueue',
    value: function processQueue() {
      var events = this.getQueue().splice(0);
      if (events.length > 0) {
        this.sendEventsToRemote(events);
      }
    }
  }, {
    key: 'handlePageUnload',
    value: function handlePageUnload() {
      this.processQueue();
      this.stopInterval();
    }

    /**
     * Start the interval. If it's already running, do nothing.
     */

  }, {
    key: 'startInterval',
    value: function startInterval() {
      var _this2 = this;

      if (typeof this._intervalId === "number") {
        return;
      }
      this._intervalId = setInterval(function () {
        return _this2.processQueue();
      }, this.batch_interval_ms);
    }
  }, {
    key: 'stopInterval',
    value: function stopInterval() {
      if (typeof this._intervalId === "number") {
        clearInterval(this._intervalId);
        this._intervalId = null;
      }
    }
  }, {
    key: 'emptyQueue',
    value: function emptyQueue() {
      this._requestQueue = [];
    }
  }, {
    key: 'sendEventsToRemote',
    value: function sendEventsToRemote(events) {
      var payload = this.constructor.createPayload(events);

      if (this.devMode) {
        _AnalyticsLogger2.default.log('sending ' + events.length + ' events.');
        return;
      }

      var successfullyQueued = false;
      if (_Beacon.Beacon.isSupported()) {
        successfullyQueued = _Beacon.Beacon.sendAsJson(this.url(), payload);
      }
      if (!successfullyQueued) {
        this.doPost(payload);
      }
    }
  }, {
    key: 'doPost',
    value: function doPost(postBody) {
      var xhr = void 0;
      if (typeof window !== "undefined" && window.XMLHttpRequest) {
        // IE7+, Firefox, Chrome, Opera, Safari
        xhr = new window.XMLHttpRequest();
      } else {
        return;
      }

      xhr.open("POST", this.url(), true);
      if (typeof xhr.setRequestHeader !== 'undefined') {
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.setRequestHeader("Accept", "application/json, text/javascript, */*;");
      }
      var decoratedPostBody = this.decorateEventsWithType(postBody);

      xhr.send(JSON.stringify(decoratedPostBody));
    }
  }, {
    key: 'decorateEventsWithType',
    value: function decorateEventsWithType(postBody) {
      return postBody.map(function (event) {
        event.properties = event.properties || {};
        event.properties._type = "xhr";
        return event;
      });
    }

    /**
     * Ensure that event properties have all values stripped of PII
     * @param data
     * @returns {*}
     */

  }, {
    key: 'sanitizeAnalyticsData',
    value: function sanitizeAnalyticsData(data) {
      var _this3 = this;

      if (isNull(data) || typeof data === 'undefined') {
        return data;
      }
      if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) !== 'object') {
        return {};
      }

      // return the data with privacy unsafe data filtered out
      return Object.keys(data).reduce(function (filteredData, key) {
        var value = data[key];
        if (isPrivacySafeAttributeKey(key) || isPrivacySafe(value)) {
          filteredData[key] = value;
        } else {
          if (_this3.devMode) {
            _AnalyticsLogger2.default.warn('Stripping out potentially privacy-unsafe analytics attribute: \'' + key + '\' -> \'' + value + '\'');
          }
        }
        return filteredData;
      }, {});
    }

    /**
     * Update and override any options provided when instantiating.
     * @param newOptions
     */

  }, {
    key: 'updateOptions',
    value: function updateOptions(newOptions) {
      this.options = _extends({}, this.options, newOptions);
    }
  }], [{
    key: 'createPayload',
    value: function createPayload(events) {
      throw new Error('You must override createPayload().');
    }
  }]);

  return BaseAnalytics;
}();

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloudAnalytics = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseAnalytics2 = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Common code for cloud, shared by JiraAnalytics and ConfluenceAnalytics
 */
var CloudAnalytics = exports.CloudAnalytics = function (_BaseAnalytics) {
  _inherits(CloudAnalytics, _BaseAnalytics);

  function CloudAnalytics() {
    _classCallCheck(this, CloudAnalytics);

    return _possibleConstructorReturn(this, (CloudAnalytics.__proto__ || Object.getPrototypeOf(CloudAnalytics)).apply(this, arguments));
  }

  _createClass(CloudAnalytics, [{
    key: 'createRequest',
    value: function createRequest(name) {
      var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return { name: name, properties: properties, serverTime: Date.now() };
    }
  }], [{
    key: 'createPayload',
    value: function createPayload(events) {
      return this.adjustEventTimings(events);
    }
  }, {
    key: 'adjustEventTimings',
    value: function adjustEventTimings(events) {
      var now = Date.now();
      return events.map(function (event) {
        return {
          name: event.name,
          properties: event.properties,
          timeDelta: event.serverTime - now
        };
      });
    }
  }]);

  return CloudAnalytics;
}(_BaseAnalytics2.BaseAnalytics);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfluenceAnalytics = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _default = __webpack_require__(0);

var _CloudAnalytics2 = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Analytics client for Confluence
 * Defaults to /wiki
 */
var ConfluenceAnalytics = exports.ConfluenceAnalytics = function (_CloudAnalytics) {
  _inherits(ConfluenceAnalytics, _CloudAnalytics);

  function ConfluenceAnalytics() {
    _classCallCheck(this, ConfluenceAnalytics);

    return _possibleConstructorReturn(this, (ConfluenceAnalytics.__proto__ || Object.getPrototypeOf(ConfluenceAnalytics)).apply(this, arguments));
  }

  _createClass(ConfluenceAnalytics, [{
    key: 'url',


    /**
     * Override if context path changes
     * @param baseUrl
     * @returns {string}
     */
    value: function url() {
      var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.hostname + _default.CONFLUENCE_URL_PREFIX;

      return baseUrl + _default.CLOUD_ANALYTICS_URL;
    }
  }]);

  return ConfluenceAnalytics;
}(_CloudAnalytics2.CloudAnalytics);

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GasAnalytics = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _default = __webpack_require__(0);

var _BaseAnalytics2 = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Analytics client for the GAS API ({@link https://extranet.atlassian.com/display/MOD/Public+Analytics+aka+GAS})
 */
var GasAnalytics = exports.GasAnalytics = function (_BaseAnalytics) {
    _inherits(GasAnalytics, _BaseAnalytics);

    /**
    * @constructor
    * @param {object} options - Required: server, product, user.
    */
    function GasAnalytics(options) {
        _classCallCheck(this, GasAnalytics);

        var _this = _possibleConstructorReturn(this, (GasAnalytics.__proto__ || Object.getPrototypeOf(GasAnalytics)).call(this, options));

        if (!options.server) {
            throw new Error("You must specify a GAS server value.");
        }
        if (!options.product) {
            throw new Error("You must specify a GAS product value.");
        }
        if (!options.user && !options.user_id) {
            throw new Error("You must specify a GAS user or user_id value.");
        }
        return _this;
    }

    _createClass(GasAnalytics, [{
        key: "url",
        value: function url() {
            return _default.GAS_BULK_URL;
        }
    }, {
        key: "createRequest",
        value: function createRequest(name) {
            var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            return {
                name: name,
                server: this.options.server,
                product: this.options.product,
                user: this.options.user,
                serverTime: Date.now(),
                cloud_id: this.options.cloud_id || null,
                user_id: this.options.user_id || null,
                user_id_type: this.options.user_id_type || null,
                properties: properties
            };
        }

        /**
         * Overrides the BaseAnalytics version in order to adhere to the GAS format, as seen in createPayload
         * @param postBody
         */

    }, {
        key: "decorateEventsWithType",
        value: function decorateEventsWithType(postBody) {
            if (!postBody.events) {
                return;
            }

            postBody.events = postBody.events.map(function (event) {
                event.properties = event.properties || {};
                event.properties._type = "xhr";
                return event;
            });

            return postBody;
        }

        /**
         * Update and override any options provided when instantiating.
         * Important: This will update any events still in the queue
         * @param newOptions
         */

    }, {
        key: "updateOptions",
        value: function updateOptions(newOptions) {
            this.options = _extends({}, this.options, newOptions);
            this.setQueue(this.getQueue().map(function (queuedEvent) {
                return _extends({}, queuedEvent, newOptions);
            }));
        }
    }], [{
        key: "createPayload",
        value: function createPayload(events) {
            return {
                events: events
            };
        }
    }]);

    return GasAnalytics;
}(_BaseAnalytics2.BaseAnalytics);

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JiraAnalytics = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _default = __webpack_require__(0);

var _CloudAnalytics2 = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Analytics client for JIRA
 */
var JiraAnalytics = exports.JiraAnalytics = function (_CloudAnalytics) {
  _inherits(JiraAnalytics, _CloudAnalytics);

  function JiraAnalytics() {
    _classCallCheck(this, JiraAnalytics);

    return _possibleConstructorReturn(this, (JiraAnalytics.__proto__ || Object.getPrototypeOf(JiraAnalytics)).apply(this, arguments));
  }

  _createClass(JiraAnalytics, [{
    key: 'url',


    /**
     * Override if context path changes
     * @param baseUrl
     * @returns {string}
     */
    value: function url() {
      var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.hostname;

      return baseUrl + _default.CLOUD_ANALYTICS_URL;
    }
  }]);

  return JiraAnalytics;
}(_CloudAnalytics2.CloudAnalytics);

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dangerouslyCreateSafeString = exports.isSafeString = exports.markAsSafe = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _GasAnalytics = __webpack_require__(5);

var _JiraAnalytics = __webpack_require__(6);

var _ConfluenceAnalytics = __webpack_require__(4);

var _PrivacySafeString = __webpack_require__(1);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Get singleton Analytics Client that is appropriate for your product or app.
 */
var AnalyticsClientFactory = function () {
  function AnalyticsClientFactory() {
    _classCallCheck(this, AnalyticsClientFactory);
  }

  _createClass(AnalyticsClientFactory, [{
    key: 'getGasClient',


    /**
     * Get a Gas Analytics Client.
     * @param {object} options - {
     *  server: "String - required",
     *  product: "String - required",
     *  user: "String - required",
     *  eventPrefix: "String - optional - default: ''",
     *  devMode: "Boolean - optional - default: false",
     *  batchIntervalMs: "Integer - optional - default: 5000"
     * }
     * @returns {GasAnalytics}
     */
    value: function getGasClient(options) {
      if (this._gasClient) {
        return this._gasClient;
      }
      return this._gasClient = new _GasAnalytics.GasAnalytics(options);
    }

    /**
     * Get a JIRA Analytics Client.
     * @param {object} options - {
     *  eventPrefix: "String - optional - default: ''",
     *  devMode: "Boolean - optional - default: false",
     *  batchIntervalMs: "Integer - optional - default: 5000"
     * }
     * @returns {JiraAnalytics}
     */

  }, {
    key: 'getJiraClient',
    value: function getJiraClient(options) {
      if (this._jiraClient) {
        return this._jiraClient;
      }
      return this._jiraClient = new _JiraAnalytics.JiraAnalytics(options);
    }

    /**
     * Get a Confluence Analytics Client.
     * @param {object} options - {
     *  eventPrefix: "String - optional - default: ''",
     *  devMode: "Boolean - optional - default: false",
     *  batchIntervalMs: "Integer - optional - default: 5000"
     * }
     * @returns {ConfluenceAnalytics}
     */

  }, {
    key: 'getConfluenceClient',
    value: function getConfluenceClient(options) {
      if (this._confluenceClient) {
        return this._confluenceClient;
      }
      return this._confluenceClient = new _ConfluenceAnalytics.ConfluenceAnalytics(options);
    }
  }]);

  return AnalyticsClientFactory;
}();

exports.default = new AnalyticsClientFactory();

/**
 * Provide a list of acceptable values to ensure we do not unintentionally capture user data
 * @param {...String} allowedStrings - Static string values representing allowed words for this property
 * @returns {SafeString} - a function that will check if the value (argument) is in the list of allowedStrings
 */

var markAsSafe = exports.markAsSafe = _PrivacySafeString.markAsSafe;
var isSafeString = exports.isSafeString = _PrivacySafeString.isSafeString;
var dangerouslyCreateSafeString = exports.dangerouslyCreateSafeString = _PrivacySafeString.dangerouslyCreateSafeString;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _isSupported = null;

/**
 * Light wrapper around navigator.sendBeacon()
 */

var Beacon = exports.Beacon = function () {
    function Beacon() {
        _classCallCheck(this, Beacon);
    }

    _createClass(Beacon, null, [{
        key: 'sendAsJson',


        /**
         * Send the specified object as JSON using Beacon API.
         *
         * See:
         * - https://developer.mozilla.org/en-US/docs/Web/API/Beacon_API
         * - https://w3c.github.io/beacon/#dom-navigator-sendbeacon
         *
         * Returns a boolean to indicate that the data was successfully queued.
         *
         * If we've exceeded our quota for sendBeacon on this page, this method
         * will return false.
         *
         * See: https://www.w3.org/TR/beacon/#sec-sendBeacon-method
         *
         * @param url
         * @param object
         * @returns {boolean}
         */
        value: function sendAsJson(url, object) {
            var blob = new Blob([JSON.stringify(object)], { type: 'text/plain' });
            return navigator.sendBeacon(url, blob);
        }

        /**
         * Returns a boolean to indicate whether Beacon is supported.
         */

    }, {
        key: 'isSupported',
        value: function isSupported() {
            if (typeof _isSupported !== 'boolean') {
                _isSupported = this.isSendBeaconSupported() && this.isBlobSupported();
            }
            return _isSupported;
        }

        /**
         * Returns a boolean to indicate whether navigator.sendBeacon is available.
         */

    }, {
        key: 'isSendBeaconSupported',
        value: function isSendBeaconSupported() {
            // Modified from: https://github.com/Modernizr/Modernizr/blob/master/feature-detects/network/beacon.js
            return 'sendBeacon' in navigator && typeof navigator.sendBeacon === 'function';
        }

        /**
         * Returns a boolean to indicate whether Blob is available.
         */

    }, {
        key: 'isBlobSupported',
        value: function isBlobSupported() {
            // Source: https://github.com/Modernizr/Modernizr/blob/master/feature-detects/blob.js
            try {
                return !!new Blob();
            } catch (e) {
                return false;
            }
        }
    }]);

    return Beacon;
}();

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Prettifier with a standard prefix for all log messages
 */
/*eslint no-console: 0*/
exports.default = {
  log: function log(message) {
    console.log("%cAnalytics: " + message, "color: #0052CC; font-size: small");
  },
  warn: function warn(message) {
    console.warn("%cAnalytics: " + message, "color: #DE350B; font-size: small");
  },
  error: function error(message) {
    // This might not work in some browsers... but ignore this for now.
    console.error("%cAnalytics: " + message, "color: #FF5630; font-size: small");
  }
};

/***/ })
/******/ ]);
});